module.exports = __webpack_public_path__ + "img/75.de999b96.jpg";